<template>
  <div class="analysis-wrapper">
    <div class="section-item">
      <over-view></over-view>
    </div>
    <div class="section-item">
      <tabs-navigation></tabs-navigation>
    </div>
  </div>
</template>

<script>
import overView from './components/overview/overview'
import tabsNavigation from './components/tabsNavigation/tabsNavigation'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'OrderDistribution',
  mixins: [pagePathMixin],
  components: { 
    overView,
    tabsNavigation
  }
}
</script>

<style lang="stylus" scoped>
  // .analysis-wrapper
  //   height calc(100vh - 85px)
  //   display flex
  //   flex-direction column
  //   .section-item:nth-child(1)
  //     height auto
  //   .section-item:nth-child(2)
  //     flex 1
  //   .section-item
  //     margin 10px
  //   .section-item+.section-item
  //     margin-top 0
  .analysis-wrapper
    height calc(100vh - 65px)
    padding 0.1px
    position relative
    overflow-y auto
    .section-item
      margin 10px
    .section-item+.section-item
      margin-top 0
  >>> .el-main
    padding 10px 20px

  >>> .high-light
    color #1890FF !important
  
  >>> .el-icon-warning-outline
    font-size 16px
</style>